import React, { useState, useEffect, useContext, useMemo } from 'react';
import { CSVLink }                                from "react-csv";
import { capitalizeWords, checkIfEmpty }                        from 'functions/functions';
import { ToastContainer, toast }                  from 'react-toastify';
import { getAllOutStandingKeys, addNote }                  from '../../services/keyServices';
import moment from 'moment';
import Modal                                      from 'react-modal';
import DataTable                                  from "react-data-table-component";
import DataTableSkeleton                          from 'components/skeleton/dataTableSkeleton';
import DashboardLayout                            from '../../layouts/dashboardLayout';
import UserContext                                from '../../contexts/userContext';
import BasicInput                                 from 'components/inputs/basicInput';
import BasicThemeButton                           from 'components/buttons/basicThemeButton';
import location_icon                              from '../../images/location-pin.png';
import { showSuccessToast, showErrorToast } from 'utils/toasts';
import useGlobalOutstandingKeys from './useGlobalOutStandingKeys';
import SelectInput from 'components/inputs/selectInput';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    width : '35%',
    transform: 'translate(-50%, -50%)',
    minHeight : '30%'
  },
};


function GlobalOutstandingKeysScreen() {

  const {user} = useContext(UserContext);

  const {
    data, 
    searchValue, onSearchValueChanges, setSearchValue, onLocationClick,
    columns, header,
    loading,
    rowClick, modalIsOpen, closeModal, modalData,
    noteValue, setNoteValue, addNoteValue, buildingOptions,
    selectedBuilding, setSelectedBuilding
  } = useGlobalOutstandingKeys(); 

  const filteredData = useMemo(() => {
  return data.filter(item => {
    const matchesSearch = !searchValue ||
      item.visitorName?.toLowerCase().includes(searchValue.toLowerCase()) ||
      item.tag?.toLowerCase().includes(searchValue.toLowerCase());

    const matchesBuilding = !selectedBuilding || selectedBuilding === "all" || item.buildingID === selectedBuilding;

    return matchesSearch && matchesBuilding;
  });
}, [data, searchValue, selectedBuilding]);

  
  return (
      <DashboardLayout pageTitle="Global Outstanding Keys">
          <div className="row gap-1" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {/* Left group: Select + Search */}
            <div className='row gap-1' style={{ flex: 1, maxWidth: '50%' }}>
              <SelectInput 
                label={false} 
                placeholder="Select Building" 
                options={buildingOptions} 
                selectedOption={selectedBuilding} 
                isSearchable={true}
                filterOption={(option, input) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                onChange={(e) => setSelectedBuilding(e.value)} 
              />
              <BasicInput  
                placeholder="Search by Visitor Name or Key Tag" 
                value={searchValue} 
                setValue={setSearchValue} 
                onChange={onSearchValueChanges} 
              />
            </div>

            {/* Right: Export button */}
            <div className="export-data">
              <CSVLink data={data} headers={header} filename="Outstanding_keys.csv" style={{ display: 'inline-block' }}>
                <BasicThemeButton title="Export to CSV" />
              </CSVLink>
            </div>
          </div>
          <div className="table-container">
            {loading ?
            <DataTableSkeleton /> :
            <DataTable
              columns={columns}
              onRowClicked={rowClick}
              data={filteredData}
              highlightOnHover
              pagination
              paginationPerPage={10}
              paginationRowsPerPageOptions={[3, 5, 10, 15, 20]}
              paginationComponentOptions={{
                rowsPerPageText: "Records per page:",
                rangeSeparatorText: "out of"
              }}
            /> }
          </div>


          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal">
              <div className="modal-content outstanding-keys-modal">
                  <h2>{modalData.tag} - {modalData.keyNumber}</h2>
                  <div className='row'>
                    <div className='key-issue-details'>
                      <p><span className='bold'>Building Name : </span>{modalData.buildingName}</p>
                      <p><span className='bold'>Visitor Name : </span>{modalData.visitorName}</p>
                      <p><span className='bold'>Company : </span>{modalData.visitorCompany}</p>
                      <p><span className='bold'>Email : </span>{modalData.visitorEmail}</p>
                      <p><span className='bold'>Phone No. : </span>{modalData.visitorPhone}</p>
                      <p><span className='bold'>Issue Time. : </span>{modalData.issueTime}</p>
                      <p><span className='bold'>Location : </span><a className='link' onClick={() => onLocationClick(modalData.location)}>See Location</a></p>
                    </div>
                    <div className='notes'>
                      <form>
                      <div className='row'>
                        <div className='left'>
                          <BasicInput value={noteValue} onChange={(e) => setNoteValue(e.target.value)} placeholder="Enter Notes (if any)" />
                        </div>
                        <div className='right'>
                          <BasicThemeButton title="Add Note" onClick={addNoteValue} />
                        </div>
                      </div>
                      </form>
                      <div className='notes-list'>
                        {modalData.notes?.length > 0 ? modalData.notes.slice().sort(((a,b) => b.timestamp - a.timestamp)).map((note, index) => {
                          return (
                            <div className='note' key={index}>
                              <p>{note.note}</p>
                              <p className='timestamp'>{note.userName ? `${capitalizeWords(note.userName)} - `: ''} {moment(note?.timestamp.toDate()).format('MM/DD/YYYY hh:mm a')}</p>
                            </div>
                          )
                        }) : <p>No Notes Added</p>}
                        
                      </div>
                    </div>
                  </div>
              </div>
          </Modal>
      </DashboardLayout>
  )
}

export default GlobalOutstandingKeysScreen